import FlatList from './FlatList';

export default FlatList;
